<template>
  <div class="role-dropdown">
    <div
      v-if="label"
      class="role-dropdown__label"
    >
      {{ label }}
    </div>
    <div class="role-dropdown__select">
      <SelectField
        :value="value"
        :options="options"
        :disabled="disabled"
        placeholder="Select a user role"
        size="md"
        placement="bottom-end"
        :show-icon-prepend="false"
        :hotkeys-enabled="false"
        :item-height="60"
        :match-trigger-width="false"
        @input="onSelect"
      >
        <template #option="{ option, selected }">
          <ListItemWithState
            class="role-dropdown__select__item"
            :selected="selected"
            wrap
            full-width
          >
            <div class="role-dropdown__select__item__row">
              <div>
                <p class="role-dropdown__select__item__title">{{ option.text }}</p>
                <p class="role-dropdown__select__item__description">
                  {{ option.description }}
                </p>
              </div>
              <Icon
                v-if="selected"
                class="role-dropdown__select__item__icon"
                name="fill-checked-circled"
              />
            </div>
          </ListItemWithState>
        </template>
      </SelectField>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'RoleDropdown',
}
</script>

<script lang="ts" setup>
import ListItemWithState from '@/uiKit/List/ListItemWithState.vue'
import SelectField from '@/uiKit/SelectField/SelectField.vue'
import type { OptionType } from '@/uiKit/types'
import Icon from '@/uiKit/Icon/Icon.vue'

import type { RoleDropdownOption } from './roleDropdownTypes'

withDefaults(
  defineProps<{
    value: string | OptionType[]
    options: RoleDropdownOption[]
    label?: string
    disabled?: boolean
  }>(),
  {
    label: '',
    disabled: false,
  },
)
const emit = defineEmits<{
  (e: 'input', value: RoleDropdownOption['id']): void
}>()

const onSelect = (val: RoleDropdownOption): void => emit('input', val.id)
</script>

<style lang="scss" scoped>
@import '@/uiKit/assets/spacings.scss';
@import '@/uiKit/assets/typography.scss';

.role-dropdown {
  position: relative;
  width: 100%;
  cursor: pointer;
}

.role-dropdown__label {
  @include typographyRegularBody200;
  color: var(--color-text-subtle);
  margin-bottom: 4px;
}

.role-dropdown__select {
  width: 100%;
  height: 36px;

  &__item {
    width: 300px;

    &__row {
      @include row--distributed;
      color: var(--color-text-default);
    }

    &__title {
      @include typographyBoldBody100;
    }

    &__description {
      @include typographyRegularBody100;
      color: var(--color-text-subtle);
    }

    &__icon {
      color: var(--color-text-subtle);
    }
  }
}
</style>
